/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreCommonExcelExportExcelRequest,
  FacilityFlowCoreCommonExcelImportResultDto,
  FacilityFlowCoreModulesCustomersDtosCreateObjectRequest,
  FacilityFlowCoreModulesCustomersDtosCreateObjectResponse,
  FacilityFlowCoreModulesCustomersDtosListObjectsResponse,
  FacilityFlowCoreModulesCustomersDtosObjectDto,
  FacilityFlowCoreModulesCustomersDtosReorderObjectsRequest,
  FacilityFlowCoreModulesCustomersDtosSetActiveOfferRequest,
  FacilityFlowCoreModulesCustomersDtosUpdateObjectRequest,
  FacilityFlowCoreModulesCustomersDtosUpdateObjectResponse,
  GetApiV1ObjectsParams,
  PostApiV1ObjectsImportExcelBody,
  PostApiV1ObjectsImportExcelParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getObjects = () => {
/**
 * @summary Create a new object
 */
const postApiV1Objects = (
    facilityFlowCoreModulesCustomersDtosCreateObjectRequest: FacilityFlowCoreModulesCustomersDtosCreateObjectRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesCustomersDtosCreateObjectResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesCustomersDtosCreateObjectResponse>(
      {url: `/api/v1/objects`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesCustomersDtosCreateObjectRequest
    },
      options);
    }
  /**
 * @summary List objects with filtering, sorting and pagination
 */
const getApiV1Objects = (
    params?: GetApiV1ObjectsParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesCustomersDtosListObjectsResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesCustomersDtosListObjectsResponse>(
      {url: `/api/v1/objects`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Get object by ID with details
 */
const getApiV1ObjectsId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesCustomersDtosObjectDto>>,) => {
      return customInstance<FacilityFlowCoreModulesCustomersDtosObjectDto>(
      {url: `/api/v1/objects/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update an existing object
 */
const putApiV1ObjectsId = (
    id: string,
    facilityFlowCoreModulesCustomersDtosUpdateObjectRequest: FacilityFlowCoreModulesCustomersDtosUpdateObjectRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesCustomersDtosUpdateObjectResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesCustomersDtosUpdateObjectResponse>(
      {url: `/api/v1/objects/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesCustomersDtosUpdateObjectRequest
    },
      options);
    }
  /**
 * @summary Delete an object
 */
const deleteApiV1ObjectsId = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/objects/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Download all objects as an Excel workbook. Customer and responsible contact are
rendered as dropdowns, so the file can be filled in without knowing any IDs.
 */
const postApiV1ObjectsExportExcel = (
    facilityFlowCoreCommonExcelExportExcelRequest: FacilityFlowCoreCommonExcelExportExcelRequest,
 options?: SecondParameter<typeof customInstance<Blob>>,) => {
      return customInstance<Blob>(
      {url: `/api/v1/objects/export/excel`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreCommonExcelExportExcelRequest,
        responseType: 'blob'
    },
      options);
    }
  /**
 * @summary Import an edited object workbook. With `dryRun=true` (the default) the
response is a preview and nothing is written.
 */
const postApiV1ObjectsImportExcel = (
    postApiV1ObjectsImportExcelBody: PostApiV1ObjectsImportExcelBody,
    params?: PostApiV1ObjectsImportExcelParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreCommonExcelImportResultDto>>,) => {const formData = new FormData();
if(postApiV1ObjectsImportExcelBody.file !== undefined) {
 formData.append(`file`, postApiV1ObjectsImportExcelBody.file)
 }
if(postApiV1ObjectsImportExcelBody.excludeRows !== undefined) {
 postApiV1ObjectsImportExcelBody.excludeRows.forEach(value => formData.append(`excludeRows`, value));
 }

      return customInstance<FacilityFlowCoreCommonExcelImportResultDto>(
      {url: `/api/v1/objects/import/excel`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData,
        params
    },
      options);
    }
  /**
 * @summary Set or unset the active offer of an object. The active offer drives recurring
monthly invoicing positions. Pass `offerId = null` to unset.
 */
const patchApiV1ObjectsIdActiveOffer = (
    id: string,
    facilityFlowCoreModulesCustomersDtosSetActiveOfferRequest: FacilityFlowCoreModulesCustomersDtosSetActiveOfferRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/objects/${id}/active-offer`, method: 'PATCH',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesCustomersDtosSetActiveOfferRequest
    },
      options);
    }
  /**
 * @summary Reorder objects for a customer
 */
const putApiV1ObjectsCustomersCustomerIdReorder = (
    customerId: string,
    facilityFlowCoreModulesCustomersDtosReorderObjectsRequest: FacilityFlowCoreModulesCustomersDtosReorderObjectsRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/objects/customers/${customerId}/reorder`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesCustomersDtosReorderObjectsRequest
    },
      options);
    }
  return {postApiV1Objects,getApiV1Objects,getApiV1ObjectsId,putApiV1ObjectsId,deleteApiV1ObjectsId,postApiV1ObjectsExportExcel,postApiV1ObjectsImportExcel,patchApiV1ObjectsIdActiveOffer,putApiV1ObjectsCustomersCustomerIdReorder}};
export type PostApiV1ObjectsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getObjects>['postApiV1Objects']>>>
export type GetApiV1ObjectsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getObjects>['getApiV1Objects']>>>
export type GetApiV1ObjectsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getObjects>['getApiV1ObjectsId']>>>
export type PutApiV1ObjectsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getObjects>['putApiV1ObjectsId']>>>
export type DeleteApiV1ObjectsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getObjects>['deleteApiV1ObjectsId']>>>
export type PostApiV1ObjectsExportExcelResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getObjects>['postApiV1ObjectsExportExcel']>>>
export type PostApiV1ObjectsImportExcelResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getObjects>['postApiV1ObjectsImportExcel']>>>
export type PatchApiV1ObjectsIdActiveOfferResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getObjects>['patchApiV1ObjectsIdActiveOffer']>>>
export type PutApiV1ObjectsCustomersCustomerIdReorderResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getObjects>['putApiV1ObjectsCustomersCustomerIdReorder']>>>
